import { GenericObjectType } from "~/utils/types";

/**
 * This function returns false if the user has not givent consent to trackings, so we use this function to block them.
 */
const ACCEPT_COOKIE_NAME = "SoleCookieAccept";
const ACCEPT_COOKIE_VALUE = "Y";

const canTrack = () => {
  if (process.client) {
    const consentCookie = document && document.cookie.split(';').find(el => el.includes(ACCEPT_COOKIE_NAME));
    const hasConsent = consentCookie && consentCookie.includes(`=${ACCEPT_COOKIE_VALUE}`);
    
    return hasConsent;
  }

  return false;
}

type SoleWindow = Window & typeof globalThis & { utag: GenericObjectType, utag_data: GenericObjectType}

export const trackView = (datas) => {
  if (!canTrack()) {
    return;
  }
  
  const w = window as SoleWindow;
  
  try {
    if (!w.utag?.view) {
      return;
    }
    
    const finalData = { ...datas, no_view: 'no' };
    
    w.utag_data = { ...w.utag_data, ...finalData };
    w.utag.view(finalData);
    
  } catch (e) {
    // Silent error
  }
}

export const trackLink = (datas, callback?: Function, message?: string) => {
  if (!canTrack()) {
    if (callback) callback();
    return;
  }

  try {
    const w = window as SoleWindow;
    
    if (!w.utag?.link) {
      if (callback) callback();
      return;
    }
    
    w.utag.link({ ...datas });
    
  } catch (e) {
    // Silent tracking error - non bloccare il flusso
  }
  
  if (callback) callback();
}

// Export delle funzioni per iniziative speciali
export * from './iniziativeSpeciali';
